<div class="grid" *ngIf="loading">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!loading">
  <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event.index)">
    <p-accordionTab header="{{ 'RENEGOCIO.LBL_TITLEPLAZO' | translate }}"
                    [selected]="tabSeleccionado === 'PLAZO'">
      <form [formGroup]="formularioPlazo" (ngSubmit)="onSubmitPlazo()" novalidate id="idFormularioPlazo" name="nomFormularioPlazo">
        <div class="grid form-group">
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>* {{ 'RENEGOCIO.LBL_TIPOPLAZO' | translate }}</label>
              <div>
                <p-dropdown disableTab  id="tipoPlazo" name="tipoPlazo" [options]="listPlazo"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                             formControlName="idTipoPlazo" [disabled]="editPlazo"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fp.idTipoPlazo.invalid">
                  {{ 'RENEGOCIO.LBL_TIPOPLAZO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>* {{ 'RENEGOCIO.LBL_DESDE' | translate }}</label>
              <input type="text" pInputText id="desde"
                     name="desde"
                     autocomplete="off"
                     formControlName="desde"
                     [maxlength]="10"
                     numero-entero-reactive
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fp.desde.invalid">
                {{ 'RENEGOCIO.LBL_DESDE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>* {{ 'RENEGOCIO.LBL_HASTA' | translate }}</label>
              <input type="text" pInputText id="hasta"
                     name="hasta"
                     autocomplete="off"
                     formControlName="hasta"
                     [maxlength]="10"
                     numero-entero-reactive
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fp.hasta.invalid">
                {{ 'RENEGOCIO.LBL_HASTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>* {{ 'RENEGOCIO.LBL_CANTCREDITO' | translate }}</label>
              <input type="text" pInputText id="cantidadCredito"
                     name="cantidadCredito"
                     autocomplete="off"
                     formControlName="cantidadCredito"
                     [maxlength]="10"
                     numero-entero-reactive
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fp.cantidadCredito.invalid">
                {{ 'RENEGOCIO.LBL_CANTCREDITO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons" style="border: none;">
          <div class="form-group col-12">
            <div *ngIf="!savePlazo">
              <button icon="fa fa-plus"
                      label="{{ (!editPlazo ? 'BTN_GUARDAR' : 'BTN_ACTUALIZAR')  | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="savePlazo">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_CONSULTANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnasPlazo" [loading]="loadingTablaPlazo" #dt
                   [value]="plazos" selectionMode="single"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.nombre}}</td>
                <td>{{row.desde}}</td>
                <td>{{row.hasta}}</td>
                <td>{{row.cantidadCredito}}</td>
                <td>
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" pButton
                            (click)="editarPlazo(row)"></button>
                    <button type="button" class="red-btn p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                            title="{{'BTN_INHABILITAR' | translate}}"
                            pButton (click)="eliminarPlazo(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-accordionTab>
    <p-accordionTab header="{{ 'RENEGOCIO.LBL_TITLEVINCULACION' | translate }}"
                    [selected]="tabSeleccionado === 'VINCULACION'">
      <form [formGroup]="formularioVinculacion" (ngSubmit)="onSubmitVinculacion()" novalidate id="idFormulario" name="nomFormulario">
        <div class="grid form-group">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <label>* {{ 'RENEGOCIO.LBL_VINCULACION' | translate }}</label>
              <div>
                <p-dropdown disableTab  id="vinculacion" name="vinculacion" [options]="listVinculacion"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                             formControlName="idVinculacion" [disabled]="editVinculacion"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fv.idVinculacion.invalid">
                  {{ 'RENEGOCIO.LBL_VINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4" *ngIf="mostrarCantidad">
            <div class="div-form">
              <label>* {{ 'RENEGOCIO.LBL_CANTIDAD' | translate }}</label>
              <input type="text" pInputText id="nombre"
                     name="cantidad"
                     autocomplete="off"
                     formControlName="cantidad"
                     [maxlength]="3"
                     numero-entero-reactive
              >
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && fv.cantidad.invalid">
                {{ 'RENEGOCIO.LBL_CANTIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4 pt-5">
            <div class="div-form">
              <p-checkbox label="{{ 'RENEGOCIO.LBL_MISVINCULA' | translate}}" binary="true"
                          id="indicadorVinculacion"
                          name="indicadorVinculacion"
                          (onChange)="toggleCantidad($event)"
                          formControlName="indicadorVinculacion"></p-checkbox>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons" style="border: none;">
          <div class="form-group col-12">
            <div *ngIf="!saveVinculacion">
              <button icon="fa fa-plus"
                      label="{{ (!editVinculacion ? 'BTN_GUARDAR' : 'BTN_ACTUALIZAR')  | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="saveVinculacion">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_CONSULTANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="loadingTablaVincu"
                   [value]="vinculaciones" selectionMode="single"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.tipoVinculacion}}</td>
                <td>{{row.cantidad}}</td>
                <td>
                  <p-checkbox  binary="true" [disabled]="true" [(ngModel)]="row.indicadorVinculacion"></p-checkbox>
                </td>
                <td>
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" pButton
                            (click)="editarVinculacion(row)"></button>
                    <button type="button" class="p-button p-button-secondary btn" icon="fa fa-users" data-toggle="tooltip"
                            title="{{'RENEGOCIO.BTN_UNIDAD' | translate}}" pButton *ngIf="!row.indicadorVinculacion"
                            (click)="toggleModalUnidadCredito(true, row)"></button>
                    <button type="button" class="red-btn p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                            title="{{'BTN_INHABILITAR' | translate}}"
                            pButton (click)="eliminarVinculacion(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
<p-dialog id="unidadCredito"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [contentStyle]="{'width':'600px'}"
          [(visible)]="mostrarModalUnidCredito"
          header="{{ 'RENEGOCIO.LBL_TITLECONFIG' | translate }}"
          [modal]="true">
  <div class="grid form-group">
    <div class="col-12 md:col-12 text-center">
      <button icon="fa fa-plus" label="{{'RENEGOCIO.BTN_NUMVECES' | translate }}"
              pButton class="btn-success" (click)="addUnidCredito()"></button>
    </div>
    <div class="col-12 md:col-12 content-scroll">
      <div class="grid from-group lg:col-offset-2" *ngFor="let unidad of listUnidadCredito; let i = index">
        <div class="col-12 md:col-5 lg:col-5">
          {{i + 1 }}a {{'RENEGOCIO.BTN_UNIDAD' | translate}}
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <input type="text" pInputText
                 name="cantidad"
                 autocomplete="off"
                 [(ngModel)]="unidad.unidadCredito"
                 [maxlength]="10"
                 numero-entero-reactive
          >
        </div>
        <div class="col-12 md:col-2 lg:col-2">
          <button icon="fa fa-times-circle-o" title="{{'BTN_ELIMINAR' | translate }}"
                  pButton class="btn-danger" (click)="deleteUnidCredito(i)"></button>
        </div>
      </div>
    </div>


  </div>

  <div class="grid form-footer-buttons">
    <div class="lg:col-12 md:col-12 col-12 text-center" *ngIf="!saveUnidadCredito">
      <a (click)="toggleModalUnidadCredito(false)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
      <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
              pButton class="btn-success" (click)="onSubmitUnidadCredito()"></button>
    </div>
    <div class="col-12 md:col-12 lg:col-12 text-center" *ngIf="saveUnidadCredito">
      <i class="fa fa-refresh fa-spin fa-fw"></i>
      <span>{{ 'LBL_GUARDANDO' | translate}}...</span>
    </div>
  </div>
</p-dialog>
<p-confirmDialog #cd key="eliminarVinculacion">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
